<template>
  <div class='eventDetail container mt-5 mb-5'>
    <b-btn @click="$router.go(-1)">Back</b-btn>
    <h1>{{ event.title }}</h1>
    <p v-if="event.location"><strong>Location: </strong>{{ event.location }}</p>
    <p><strong>Start Date: </strong>{{ (event.start.toDate()) | moment("dddd, MMMM Do YYYY") }}</p>
    <p><strong>Start Time: </strong>{{ (event.start.toDate()) | moment("h:mm A") }}</p>
    <p><strong>End Date: </strong>{{ (event.end.toDate()) | moment("dddd, MMMM Do YYYY") }}</p>
    <p><strong>End Time: </strong>{{ (event.end.toDate()) | moment("h:mm A") }}</p>
    <p><strong>Description: </strong></p>
    <p>{{ event.description }}</p>
    <p v-if="event.displayContact == 'show'">
      <strong>Contact: </strong>{{ event.name }} ({{event.email}})
    </p>
    <a v-if="event.link" v-bind:href="event.link" target="_blank">
      <b-btn variant="primary">More Info</b-btn>
    </a>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  data() {
    return {
      event: null,
    };
  },
  mounted() {
    const database = firebase.firestore();
    database.collection('calendars').doc(this.$route.params.calendar).collection('events').doc(this.$route.params.event)
      .get()
      .then((doc) => { this.event = doc.data(); });
  },
  methods: {
  },
};

</script>

<style lang='scss'>

</style>
